import { BrowserRouter, Route, Routes } from "react-router-dom";
import Feed from "./front/templates/Client/Feed/Feed";
import LoginPage from "./front/templates/Client/Loginpage/LoginPage";
import Profile from "./front/templates/Client/Profile/Profile";
import RegisterPage from "./front/templates/Client/Registerpage/RegisterPage";
import HomePage from "./front/templates/Homepage/HomePage";
import ProfileBartenderAdmin from "./front/templates/Bartender/ProfileBartender/ProfileBartender";
import ProfileBartenderClient from "./front/templates/Bartender/ProfileBartenderClient/ProfileBartenderClient";
import AdminPage from "./front/templates/Bartender/Admin/Admin";

function RoutesApp() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/bartender/login" element={<LoginPage />} />
                {/* <Route path="/registrar" element={<RegisterPage />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/feed" element={<Feed />} /> */}


                {/*
                <Route path="/bartender/registrar" element={<RegisterPage />} />
                <Route path="/bartender/profile/@santiago_bar" element={<ProfileBartenderClient />} /> */}
                

                <Route path="/bartender/profile/admin/:id" element={<AdminPage />} />
            </Routes>
        </BrowserRouter>
    )
}

export default RoutesApp;